import React, { Suspense } from 'react';

import {
  DetailsSidebar,
  DetailsSidebarProvider,
  DetailsSidebarTrigger,
  Icon,
  Stack,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';
import { useAnalytics } from '@eluve/posthog-react';

import { ChatPanelSkeleton } from './ChatPanelSkeleton';
import { ChatWithEluveGpt } from './ChatWithEluveGpt';

interface EluveGptTriggerProps {
  tenantId: string;
  baseUrl: string;
}

export const EluveGptTrigger: React.FC<EluveGptTriggerProps> = ({
  tenantId,
  baseUrl,
}) => {
  const { capture } = useAnalytics();

  return (
    <DetailsSidebarProvider
      overlayOnly
      onOpenChange={(open) => {
        if (open) capture('eluve_gpt_launcher_clicked');
      }}
    >
      <DetailsSidebarTrigger>
        <div className="fixed right-6 bottom-6 z-50">
          <Tooltip>
            <TooltipTrigger asChild>
              <Stack
                className="size-12 cursor-pointer rounded-full bg-bg-insights-subtle p-2"
                justify="center"
                align="center"
                aria-label="Eluve Insights"
                role="button"
                gap={2}
                direction="horizontal"
              >
                <Icon
                  name="Lightbulb"
                  size="lg"
                  className="text-text-insights"
                />
              </Stack>
            </TooltipTrigger>
            <TooltipContent side="left">Eluve Insights</TooltipContent>
          </Tooltip>
        </div>
      </DetailsSidebarTrigger>

      <DetailsSidebar size="lg" title="Eluve Insights" allowFullscreen>
        <Suspense fallback={<ChatPanelSkeleton />}>
          <ChatWithEluveGpt tenantId={tenantId} baseUrl={baseUrl} />
        </Suspense>
      </DetailsSidebar>
    </DetailsSidebarProvider>
  );
};
